import { useEffect, useState } from "react";
import axios from "axios";
import { message } from "antd";

const Moniter = () => {
    const [dataCount, setDataCount] = useState(0); // State to hold the count
    const [err, getError] = useState(null);

    useEffect(() => {
        dataHandler();
    }, []);

    const dataHandler = async () => {
        try {
            const url = `${process.env.REACT_APP_BASE_URL}Moniter/DataCount`; // Update the endpoint to request the count
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
            };

            const response = await axios.get(url, config);

            if (response.status === 200) {
                const count = parseInt(response.data); // Parse the count from the response
                setDataCount(count); // Set the count in the state
                message.success("Data count fetched successfully");
                getError([])
            }
        } catch (error) {
            getError(error.message);
            //console.log(error);
            setDataCount([])
        }
    };

    return (
        <div>
            <h2>VMS Count - {dataCount}</h2> {/* Display the count */}
            <h3>{err}</h3>            
        </div>
    );
};

export default Moniter;
